<template>
    <div>
        <el-tabs type="border-card" stretch>
            <el-tab-pane>
                <span slot="label">
                    课程目录：
                    <span class="num"> 345个 </span>
                </span>
                <CourseDirectory></CourseDirectory>
            </el-tab-pane>
            <el-tab-pane label="消息中心">
                <span slot="label">
                    课程资源 ：
                    <span class="num"> 845个 </span>
                </span>
                <CourseDirectory></CourseDirectory>
            </el-tab-pane>
            <el-tab-pane label="角色管理">
                <span slot="label">
                    开课总数：
                    <span class="num"> 2378个 </span>
                </span>
                <CourseDirectory></CourseDirectory>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import CourseDirectory from "./CourseDirectory.vue";
export default {
    components: {
        CourseDirectory,
    },
};
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__header {
    background-color: #64b0ff;
    span {
        color: #fff;
        .num {
            font-size: 24px;
            font-weight: 700;
            color: red;
        }
        .num:hover {
            color: #409eff;
        }
    }
}
::v-deep .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
    background-color: #d7d7d7;
    border: 0;
    span {
        color: #000;
        .num {
            color: red;
        }
    }
}
::v-deep .el-tabs--border-card > .el-tabs__content {
    padding: 0;
}
::v-deep .el-tabs--border-card > .el-tabs__header {
    height: 70px;
    padding-top: 30px;
    margin-top: 3px;
}
</style>